import { render, staticRenderFns } from "./imprTab.vue?vue&type=template&id=6852a1a5"
import script from "./imprTab.vue?vue&type=script&lang=js"
export * from "./imprTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6852a1a5')) {
      api.createRecord('6852a1a5', component.options)
    } else {
      api.reload('6852a1a5', component.options)
    }
    module.hot.accept("./imprTab.vue?vue&type=template&id=6852a1a5", function () {
      api.rerender('6852a1a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/ibm/imprTab.vue"
export default component.exports